// Counts WhatsApp taps as GA4 "whatsapp_click" events so Google Ads can import
// them as a conversion. The Google tag runs inside Shopify's sandboxed web
// pixel (out of reach of theme JS), so this beacons the tracking worker, which
// relays via the GA4 Measurement Protocol using the visitor's own GA cookie ids
// — the click therefore lands in their real session and keeps ads attribution.
// Loaded by all 4 SPA templates (index, cart, 404, page.peak-labs).
(function () {
  var ENDPOINT = "https://peaklabs-tracking.peaklabs.workers.dev/api/ga4-event";
  var lastSent = 0;

  function cookie(name) {
    var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : "";
  }
  function clientId() {
    var m = cookie("_ga").match(/(\d+\.\d+)$/); // "GA1.1.123.456" -> "123.456"
    return m ? m[1] : "";
  }
  function sessionId() {
    // "GS1.1.<sid>.<n>..." or "GS2.1.s<sid>$o<n>..." for stream G-KL8B7E84YV
    var m = cookie("_ga_KL8B7E84YV").match(/\.s?(\d{9,11})[.$]/);
    return m ? m[1] : "";
  }

  function report(a) {
    var now = Date.now();
    if (now - lastSent < 400) return; // click/auxclick double-fire guard
    lastSent = now;
    var body = JSON.stringify({
      event: "whatsapp_click",
      cid: clientId(),
      sid: sessionId(),
      dl: String(location.href).slice(0, 500),
      lt: String(a.getAttribute("href") || "").slice(0, 200),
    });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "text/plain" }))) return;
    } catch (e) {}
    try {
      fetch(ENDPOINT, { method: "POST", body: body, keepalive: true, headers: { "Content-Type": "text/plain" } }).catch(function () {});
    } catch (e) {}
  }

  function onTap(e) {
    if (e.type === "auxclick" && e.button !== 1) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('a[href*="wa.me"],a[href*="api.whatsapp"],a[href*="whatsapp://"]');
    if (a) report(a); // never preventDefault: the target=_blank open proceeds
  }
  // Capture phase so a stopPropagation in page code can't hide the click.
  document.addEventListener("click", onTap, true);
  document.addEventListener("auxclick", onTap, true);
})();
